<template>
  <div id="app" v-loading="isLoading">
    <router-view></router-view>
  </div>
</template>

<script>
import apis from './request/api';
export default {
  name: 'app',
  data() {
    return {
      isLoading: false
    };
  },
  components: {},
  created() {
    // ★★★挂载全局api
    for (const key in apis) {
      this.$root[key] = apis[key];
    }
  }
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
input {
  outline: none;
}
textarea {
  outline: none;
}
</style>
